/* eslint-disable no-debugger */
import { Fragment } from "react";
import useEditLSCTouchpoint from "./UseEditLSCTouchpoint";
import Headings from "@usas/ui-web/components/headings/Headings";
import DatePicker from '@usas/ui-web/components/datepickers/DatePicker';
import Dropdown from '@usas/ui-web/components/dropdowns/Dropdown';
import Textarea from '@usas/ui-web/components/inputs/Textarea';
import global from '@usas/ui-web/components/GlobalStyle.module.css';
import PrimaryButton from "@usas/ui-web/components/buttons/PrimaryButton";
import SecondaryButton from "@usas/ui-web/components/buttons/SecondaryButton";
import PopUpModal from "@usas/ui-web/components/dialogs/PopUpModal";
import Constants from "@usas/ui-web/utils/Constants";
import YesNoSwitch from "@usas/ui-web/components/yesNoSwitch/YesNoSwitch";
import ReadOnly from "@usas/ui-web/components/readOnly/ReadOnly";

const EditLSCTouchpoint = () => {
  const {
    formState,
    errorState,
    touchpointTypeState,
    touchpointSubjectState,
    lscTouchpointState,
    lscStaffOptionsState,
    lscBoardMemberOptionsState,
    handleSubmit,
    isLoading,
    location,
    onFormValueChanged,
    onValueTextPairChanged,
    onSaveClicked,
    onCancelClicked
  } = useEditLSCTouchpoint();

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">
          <Headings.H3>Edit LSC Touchpoint</Headings.H3>
        </div>
      </div>
      <form onSubmit={handleSubmit} noValidate>
        <div className="row usas-extra-top-margin usas-extra-bottom-margin">
          <div className="col-xs-12 col-sm-6 col-md-3">
            <DatePicker label="Touchpoint Date*"
              name="touchpointDate"
              value={formState.touchpointDate}
              error={errorState.touchpointDate}
              message={errorState.touchpointDate}
              onChange={(value) => { onFormValueChanged('touchpointDate', value); }}
              countOfYears={6}
              startYearOffset={-1} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-3">
            <Dropdown
              label="Touchpoint Types*"
              name="touchpointTypeId"
              value={formState.touchpointTypeId}
              error={errorState.touchpointTypeId}
              message={errorState.touchpointTypeId}
              areValuesIntegers={true}
              isLoading={touchpointTypeState.isLoading === true}
              options={touchpointTypeState.dataAsOptionsWithNames}
              onChange={(newValue, newValueLabel, e) => { onValueTextPairChanged(newValue, 'touchpointTypeId', newValueLabel, 'touchpointTypeName', e); }} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-3">
            <Dropdown
              label="Touchpoint Subjects*"
              name="touchpointSubjectId"
              value={formState.touchpointSubjectId}
              error={errorState.touchpointSubjectId}
              message={errorState.touchpointSubjectId}
              areValuesIntegers={true}
              isLoading={touchpointSubjectState.isLoading === true}
              options={touchpointSubjectState.dataAsOptionsWithNames}
              onChange={(newValue, newValueLabel, e) => { onValueTextPairChanged(newValue, 'touchpointSubjectId', newValueLabel, 'touchpointSubjectName', e); }} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-3">
            <Dropdown
              label="Board Members / Staff*"
              name="memberId"
              value={formState.memberId}
              error={errorState.memberId}
              message={errorState.memberId}
              areValuesIntegers={false}
              options={lscBoardMemberOptionsState.items}
              onChange={(newValue, newValueLabel, e) => { onValueTextPairChanged(newValue, 'memberId', newValueLabel, 'memberName', e); }} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-3">
            <DatePicker label="Follow-up Reminder Date"
              name="followUpDate"
              value={formState.followUpDate}
              error={errorState.followUpDate}
              message={errorState.followUpDate}
              onChange={(value) => { onFormValueChanged('followUpDate', value); }}
              countOfYears={5}
              startYearOffset={0} />
          </div>
        </div>
        <div className="row usas-extra-top-margin usas-extra-bottom-margin">
          <div className="col-xs-12 col-sm-12 col-md-12">
            <Textarea
              className={global.Textarea}
              label="Touchpoint Note*"
              name="touchpointNote"
              value={formState.touchpointNote}
              error={errorState.touchpointNote}
              message={errorState.touchpointNote}
              onChange={(value) => { onFormValueChanged('touchpointNote', value) }} />
          </div>
        </div>
        <div className="row usas-extra-top-margin usas-extra-bottom-margin">
          <div className="col-xs-12 col-sm-12 col-md-12">
            {location.state === null || location.state.hasCustomerSatisfactionSurvey === false ?
              <YesNoSwitch
                label="Add Customer Satisfaction Survey?"
                name="hasCustomerSatisfactionSurvey"
                checked={formState.hasCustomerSatisfactionSurvey}
                error={errorState.hasCustomerSatisfactionSurvey}
                message={errorState.hasCustomerSatisfactionSurvey}
                onChange={(value) => { onFormValueChanged('hasCustomerSatisfactionSurvey', value); }}
              /> :
              <ReadOnly
                label="Has Customer Satisfaction Survey been added?"
                name="hasCustomerSatisfactionSurvey"
                value={formState.hasCustomerSatisfactionSurvey === true ? 'Yes' : 'No'}
              />
            }
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 usas-extra-top-margin usas-extra-bottom-margin">
            <PrimaryButton type="button" onClick={onSaveClicked}>Save</PrimaryButton>&nbsp;
            <SecondaryButton type="button" onClick={onCancelClicked}>Back</SecondaryButton>
          </div>
        </div>
      </form>
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.LOADING_MSG}
        displayPopUp={isLoading} />
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.SAVING_MSG}
        displayPopUp={lscTouchpointState.isSaving} />
    </Fragment>);
};

export default EditLSCTouchpoint;